/**
 * Team Configuration
 * 
 * This file contains configuration settings for each team/project,
 * including default AWS regions for infrastructure monitoring.
 */

// Default regions for each team
// Frankfurt = eu-central-1, Ireland = eu-west-1
export const teamDefaultRegions = {
  'iCOP': 'eu-central-1',           // Frankfurt
  'IES': 'eu-central-1',            // Frankfurt
  'SMP': 'eu-central-1',            // Frankfurt
  'IRMA': 'eu-central-1',           // Frankfurt
  'MyKONE': 'eu-west-1',            // Ireland (MyKONE Delivery Ops)
  'MyKONE Delivery Ops': 'eu-west-1', // Ireland
  'MyKONE-PSR': 'eu-west-1',        // Ireland
  'MyKONE PSR': 'eu-west-1',        // Ireland
  'MyKONE-Platform': 'eu-west-1',   // Ireland
  'MyKONE Platform': 'eu-west-1',   // Ireland
  'MyKONE-CIAM': 'eu-west-1',       // Ireland
  'MyKONE CIAM': 'eu-west-1',       // Ireland
  'KONE-Support': 'eu-central-1',   // Frankfurt
  'LogBook': 'eu-west-1',           // Ireland
  'DMI': 'eu-central-1',            // Frankfurt
  'FLCAD': 'eu-central-1',          // Frankfurt
};

// Get default region for a team
export const getDefaultRegion = (teamName) => {
  return teamDefaultRegions[teamName] || 'eu-central-1'; // Default to Frankfurt if not found
};

// Available regions for selection
// iCOP only supports Frankfurt and Ireland regions
export const availableRegions = [
  { value: 'eu-central-1', label: 'Europe (Frankfurt)' },
  { value: 'eu-west-1', label: 'Europe (Ireland)' }
];

// Account ID mappings - should match backend account_config.py
export const accountMappings = {
  'iCOP': {
    'dev': '214888068672',
    'prod': '355878730084'
  },
  'IES': {
    'dev': '432520554350',
    'acc': '226078374497',
    'prod': '279110638550'
  },
  'SMP': {
    'dev': '577638395954',
    'acc': '108782074958',
    'prod': '779846812953'
  },
  'IRMA': {
    'dev': '006805626247',
    'qa': '860655786540',
    'prod': '797776192795'
  },
  'MyKONE': {
    'dev': '038462775582',
    'qa': '004078028460',
    'acc': '180294217149',
    'prod': '183295439344',
    'shared': '225989352905'
  },
  'MyKONE-PSR': {
    'dev': '339713063010',
    'acc': '975050102736',
    'prod': '381492224458',
    'shared': '767397912546'
  },
  'MyKONE-Platform': {
    'dev': '642137768470',
    'acc': '690695877684',
    'prod': '899067466555',
    'shared': '250935838651'
  },
  'MyKONE-CIAM': {
    'dev': '034362055273',
    'acc': '559050207009',
    'prod': '361769561104',
    'shared': '850995537932'
  },
  'KONE-Support': {
    'dev': '842675986936',
    'acc': '590183836753',
    'prod': '905418162753',
    'shared': '211125646482',
    'sandbox': '767398113715'
  },
  'LogBook': {
    'dev': '508152319109',
    'acc': '019660649900',
    'prod': '082095646959'
  },
  'DMI': {
    'dev': '115418228524'
  },
  'FLCAD': {
    'dev': '418295699108'
  }
};

// Team display names mapping
export const teamDisplayNames = {
  'iCOP': 'iCOP',
  'IES': 'IES',
  'SMP': 'SMP',
  'IRMA': 'IRMA',
  'MyKONE': 'MyKONE Delivery Ops',
  'MyKONE-PSR': 'MyKONE PSR',
  'MyKONE-Platform': 'MyKONE Platform',
  'MyKONE-CIAM': 'MyKONE CIAM',
  'KONE-Support': 'KONE-Support',
  'LogBook': 'LogBook',
  'DMI': 'DMI',
  'FLCAD': 'FLCAD'
};

// Convert display name to internal team name
export const toInternalTeamName = (displayName) => {
  if (displayName === 'MyKONE Delivery Ops') return 'MyKONE';
  if (displayName === 'MyKONE PSR') return 'MyKONE-PSR';
  if (displayName === 'MyKONE Platform') return 'MyKONE-Platform';
  if (displayName === 'MyKONE CIAM') return 'MyKONE-CIAM';
  return displayName;
};
